import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import MasterObat from './components/MasterObat';
import SuratPesananApotek from './components/SuratPesananApotek';
import ProsesPesananApotek from './components/ProsesPesananApotek';
import MasterPerusahaan from './components/MasterPerusahaan';
import TerimaBarangApotek from './components/TerimaBarangApotek';
import OpnameApotek from './components/OpnameApotek';
import LaporanApotek from './components/LaporanApotek';
import UserManagement from './components/UserManagement';
import GroupUser from './components/GroupUser';
import UserPermission from './components/UserPermission';
import DataPelanggan from './components/DataPelanggan';
import DataSupplier from './components/DataSupplier';
import DataSp from './components/DataSp';
import StokBarang from './components/StokBarang';
import SetupBridging from './components/SetupBridging';
import DashboardKamar from './components/DashboardKamar';
import DataKamar from './components/DataKamar';
import DataKlasifikasi from './components/DataKlasifikasi';
import DataDivisi from './components/DataDivisi';
import DataDokter from './components/DataDokter';
import DataTindakan from './components/DataTindakan';
import DataTagihanPDF from './components/DataTagihanPDF';
import DataClaimBpjs from './components/DataClaimBpjs';
import DataClaimPasien from './components/DataClaimPasien';
import DataIcd from './components/DataIcd';
import PasienRJ from './components/PasienRJ';
import TarifInacbg from './components/TarifInacbg';
import TarifKamar from './components/TarifKamar';
import DataPURS from './components/DataPURS';
import PasienRI from './components/PasienRI';
import DataPasien from './components/DataPasien';
import PoliKlinik from './components/PoliKlinik';
import DataPenunjang from './components/DataPenunjang';
import HasilLab from './components/HasilLab';
import HasilRad from './components/HasilRad';
import SignaObat from './components/SignaObat';
import RekapPiutang from './components/RekapPiutang';
import KasKasir from './components/KasKasir';
import KasBendahara from './components/KasBendahara';
import BayarPiutang from './components/BayarPiutang';
import TrsLaboratorium from './components/TrsLaboratorium';
import TrsRadiologi from './components/TrsRadiologi';
import TrsRuangRawat from './components/TrsRuangRawat';
import TrsApotek from './components/TrsApotek';
import TarifLab from './components/TarifLab';
import AturanJasaMedisBPJS from './components/AturanJasaMedisBPJS';
import PembuatanTagihan from './components/PembuatanTagihan';
import ValidasiRekananPerusahaan from './components/ValidasiRekananPerusahaan';
import LaporanRekapJurnalKasir from './components/LaporanRekapJurnalKasir';
import BayarJasaMedis from './components/BayarJasaMedis';
import AturanJual from './components/AturanJual';
import ResumeMedis from './components/ResumeMedis';
import CekKelengkapanTagihan from './components/CekKelengkapanTagihan';
import BillingGroupEklaim from './components/BillingGroupEklaim';
import ProfileApotek from './components/ProfileApotek';
import LapApotekFinance from './components/LapApotekFinance';
import BootstrapAlertModal from './components/BootstrapAlertModal';

// Komponen helper untuk membatasi akses halaman tanpa login
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
};

function App() {
  return (
    <Router>
      <BootstrapAlertModal />
      <Routes>
        {/* Route Login */}
        <Route path="/" element={<Login />} />

        {/* Route PoliKlinik */}
        <Route path="/PoliKlinik" element={<ProtectedRoute><PoliKlinik /></ProtectedRoute>} />

        {/* Route Dashboard */}
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/Home" element={<ProtectedRoute><Home /></ProtectedRoute>} />

        {/* Route Master Data Barang & Obat */}
        <Route path="/MasterObat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/MasterPerusahaan" element={<ProtectedRoute><MasterPerusahaan /></ProtectedRoute>} />
        <Route path="/masterobat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/MasterObat/*" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/masterobat/*" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/master-obat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/Master-Obat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/master_obat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/Master_Obat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/MasterBarang" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/masterbarang" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/DataBarang" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/databarang" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/DataObat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/dataobat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/MasterDataBarang" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/masterdatabarang" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/MasterDataObat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/masterdataobat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/FormObat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />
        <Route path="/formobat" element={<ProtectedRoute><MasterObat /></ProtectedRoute>} />

        {/* Route Surat Pesanan Barang / Obat Apotek */}
        <Route path="/SuratPesananApotek" element={<ProtectedRoute><SuratPesananApotek /></ProtectedRoute>} />
        <Route path="/suratpesananapotek" element={<ProtectedRoute><SuratPesananApotek /></ProtectedRoute>} />
        <Route path="/SuratPesananApotek/*" element={<ProtectedRoute><SuratPesananApotek /></ProtectedRoute>} />
        <Route path="/suratpesananapotek/*" element={<ProtectedRoute><SuratPesananApotek /></ProtectedRoute>} />

        {/* Route Proses / Pembuatan Pesanan Obat & AKSP */}
        <Route path="/ProsesPesananApotek" element={<ProtectedRoute><ProsesPesananApotek /></ProtectedRoute>} />
        <Route path="/prosespesananapotek" element={<ProtectedRoute><ProsesPesananApotek /></ProtectedRoute>} />
        <Route path="/ProsesPesananApotek/*" element={<ProtectedRoute><ProsesPesananApotek /></ProtectedRoute>} />
        <Route path="/prosespesananapotek/*" element={<ProtectedRoute><ProsesPesananApotek /></ProtectedRoute>} />

        {/* Route Tanda Terima Barang Apotek */}
        <Route path="/TerimaBarangApotek" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/terimabarangapotek" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/TerimaBarangApotek/*" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/terimabarangapotek/*" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/TarimaBarangApotek" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/tarimabarangapotek" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/TarimaBarangApotek/*" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/tarimabarangapotek/*" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/TandaTerimaBarang" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/tandaterimabarang" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/Ttb" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />
        <Route path="/ttb" element={<ProtectedRoute><TerimaBarangApotek /></ProtectedRoute>} />

        {/* Route Stok Opname Obat Apotek */}
        <Route path="/OpnameApotek" element={<ProtectedRoute><OpnameApotek /></ProtectedRoute>} />
        <Route path="/opnameapotek" element={<ProtectedRoute><OpnameApotek /></ProtectedRoute>} />
        <Route path="/OpnameApotek/*" element={<ProtectedRoute><OpnameApotek /></ProtectedRoute>} />
        <Route path="/opnameapotek/*" element={<ProtectedRoute><OpnameApotek /></ProtectedRoute>} />
        <Route path="/StokOpnameApotek" element={<ProtectedRoute><OpnameApotek /></ProtectedRoute>} />
        <Route path="/stokopnameapotek" element={<ProtectedRoute><OpnameApotek /></ProtectedRoute>} />
        <Route path="/StokOpname" element={<ProtectedRoute><OpnameApotek /></ProtectedRoute>} />
        <Route path="/stokopname" element={<ProtectedRoute><OpnameApotek /></ProtectedRoute>} />

        {/* Route Laporan Narkotika, Psikotropika, Prekursor Apotek */}
        <Route path="/LaporanApotek" element={<ProtectedRoute><LaporanApotek /></ProtectedRoute>} />
        <Route path="/laporanapotek" element={<ProtectedRoute><LaporanApotek /></ProtectedRoute>} />
        <Route path="/LaporanApotek/*" element={<ProtectedRoute><LaporanApotek /></ProtectedRoute>} />
        <Route path="/laporanapotek/*" element={<ProtectedRoute><LaporanApotek /></ProtectedRoute>} />

        {/* Route Aturan Penjualan Obat */}
        <Route path="/AturanJual" element={<ProtectedRoute><AturanJual /></ProtectedRoute>} />
        <Route path="/aturanjual" element={<ProtectedRoute><AturanJual /></ProtectedRoute>} />
        <Route path="/AturanJual/*" element={<ProtectedRoute><AturanJual /></ProtectedRoute>} />
        <Route path="/aturanjual/*" element={<ProtectedRoute><AturanJual /></ProtectedRoute>} />

        {/* Route Profil Instansi Apotek / Farmasi */}
        <Route path="/ProfileApotek" element={<ProtectedRoute><ProfileApotek /></ProtectedRoute>} />
        <Route path="/profileapotek" element={<ProtectedRoute><ProfileApotek /></ProtectedRoute>} />
        <Route path="/ProfileApotek/*" element={<ProtectedRoute><ProfileApotek /></ProtectedRoute>} />
        <Route path="/profileapotek/*" element={<ProtectedRoute><ProfileApotek /></ProtectedRoute>} />
        <Route path="/profile_apotek" element={<ProtectedRoute><ProfileApotek /></ProtectedRoute>} />
        <Route path="/Profile_Apotek" element={<ProtectedRoute><ProfileApotek /></ProtectedRoute>} />
        <Route path="/ProfilApotek" element={<ProtectedRoute><ProfileApotek /></ProtectedRoute>} />
        <Route path="/profilapotek" element={<ProtectedRoute><ProfileApotek /></ProtectedRoute>} />

        {/* Route User Management */}
        <Route path="/UserManagement" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
        <Route path="/usermanagement" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />

        {/* Route Group User */}
        <Route path="/GroupUser" element={<ProtectedRoute><GroupUser /></ProtectedRoute>} />
        <Route path="/groupuser" element={<ProtectedRoute><GroupUser /></ProtectedRoute>} />

        {/* Route Setting Permission */}
        <Route path="/UserPermision" element={<ProtectedRoute><UserPermission /></ProtectedRoute>} />
        <Route path="/userpermision" element={<ProtectedRoute><UserPermission /></ProtectedRoute>} />
        <Route path="/UserPermission" element={<ProtectedRoute><UserPermission /></ProtectedRoute>} />
        <Route path="/userpermission" element={<ProtectedRoute><UserPermission /></ProtectedRoute>} />

        {/* Route Master Data Pelanggan */}
        <Route path="/DataPelanggan" element={<ProtectedRoute><DataPelanggan /></ProtectedRoute>} />
        <Route path="/datapelanggan" element={<ProtectedRoute><DataPelanggan /></ProtectedRoute>} />

        {/* Route Master Data Supplier */}
        <Route path="/DataSupplier" element={<ProtectedRoute><DataSupplier /></ProtectedRoute>} />
        <Route path="/datasupplier" element={<ProtectedRoute><DataSupplier /></ProtectedRoute>} />

        {/* Route Surat Pesanan (SP) */}
        <Route path="/DataSp" element={<ProtectedRoute><DataSp /></ProtectedRoute>} />
        <Route path="/datasp" element={<ProtectedRoute><DataSp /></ProtectedRoute>} />

        {/* Route Stok Barang / Saldo */}
        <Route path="/StokBarang" element={<ProtectedRoute><StokBarang /></ProtectedRoute>} />
        <Route path="/stokbarang" element={<ProtectedRoute><StokBarang /></ProtectedRoute>} />

        {/* Route Dashboard Kamar */}
        <Route path="/DashboardKamar" element={<ProtectedRoute><DashboardKamar /></ProtectedRoute>} />
        <Route path="/dashboardkamar" element={<ProtectedRoute><DashboardKamar /></ProtectedRoute>} />

        {/* Route Master Data Kamar */}
        <Route path="/DataKamar" element={<ProtectedRoute><DataKamar /></ProtectedRoute>} />
        <Route path="/datakamar" element={<ProtectedRoute><DataKamar /></ProtectedRoute>} />

        {/* Route Master Data Klasifikasi */}
        <Route path="/DataKlasifikasi" element={<ProtectedRoute><DataKlasifikasi /></ProtectedRoute>} />
        <Route path="/dataklasifikasi" element={<ProtectedRoute><DataKlasifikasi /></ProtectedRoute>} />

        {/* Route Master Data Divisi */}
        <Route path="/DataDivisi" element={<ProtectedRoute><DataDivisi /></ProtectedRoute>} />
        <Route path="/datadivisi" element={<ProtectedRoute><DataDivisi /></ProtectedRoute>} />

        {/* Route Master Data Dokter */}
        <Route path="/DataDokter" element={<ProtectedRoute><DataDokter /></ProtectedRoute>} />
        <Route path="/datadokter" element={<ProtectedRoute><DataDokter /></ProtectedRoute>} />

        {/* Route Master Data Tindakan */}
        <Route path="/DataTindakan" element={<ProtectedRoute><DataTindakan /></ProtectedRoute>} />
        <Route path="/datatindakan" element={<ProtectedRoute><DataTindakan /></ProtectedRoute>} />

        {/* Route Penagihan BPJS */}
        <Route path="/DataTagihanPDF" element={<ProtectedRoute><DataTagihanPDF /></ProtectedRoute>} />
        <Route path="/datatagihanpdf" element={<ProtectedRoute><DataTagihanPDF /></ProtectedRoute>} />

        {/* Route Data Claim BPJS (Grouper E-Claim) */}
        <Route path="/DataClaimBpjs" element={<ProtectedRoute><DataClaimBpjs /></ProtectedRoute>} />
        <Route path="/dataclaimbpjs" element={<ProtectedRoute><DataClaimBpjs /></ProtectedRoute>} />

        {/* Route Data Klaim Pasien RI */}
        <Route path="/DataClaimPasien" element={<ProtectedRoute><DataClaimPasien /></ProtectedRoute>} />
        <Route path="/dataclaimpasien" element={<ProtectedRoute><DataClaimPasien /></ProtectedRoute>} />

        {/* Route Template Billing Group E-Klaim */}
        <Route path="/BillingGroup" element={<ProtectedRoute><BillingGroupEklaim /></ProtectedRoute>} />
        <Route path="/billinggroup" element={<ProtectedRoute><BillingGroupEklaim /></ProtectedRoute>} />
        <Route path="/billing_group" element={<ProtectedRoute><BillingGroupEklaim /></ProtectedRoute>} />
        <Route path="/BillingGroupEklaim" element={<ProtectedRoute><BillingGroupEklaim /></ProtectedRoute>} />
        <Route path="/billinggroupeklaim" element={<ProtectedRoute><BillingGroupEklaim /></ProtectedRoute>} />

        {/* Route Setup Bridging */}
        <Route path="/SetupBridging" element={<ProtectedRoute><SetupBridging /></ProtectedRoute>} />
        <Route path="/setupbridging" element={<ProtectedRoute><SetupBridging /></ProtectedRoute>} />
        <Route path="/setup_bridging" element={<ProtectedRoute><SetupBridging /></ProtectedRoute>} />
        <Route path="/Setup Bridging" element={<ProtectedRoute><SetupBridging /></ProtectedRoute>} />
        <Route path="/setup bridging" element={<ProtectedRoute><SetupBridging /></ProtectedRoute>} />

        {/* Route Master Data ICD-10 & ICD-9 */}
        <Route path="/DataIcd" element={<ProtectedRoute><DataIcd /></ProtectedRoute>} />
        <Route path="/dataicd" element={<ProtectedRoute><DataIcd /></ProtectedRoute>} />

        {/* Route Pendaftaran Pasien Rawat Jalan */}
        <Route path="/PasienRJ" element={<ProtectedRoute><PasienRJ /></ProtectedRoute>} />
        <Route path="/pasienrj" element={<ProtectedRoute><PasienRJ /></ProtectedRoute>} />

        {/* Route Master Tarif INA-CBG's */}
        <Route path="/TarifInacbg" element={<ProtectedRoute><TarifInacbg /></ProtectedRoute>} />
        <Route path="/tarifinacbg" element={<ProtectedRoute><TarifInacbg /></ProtectedRoute>} />

        {/* Route Master Tarif Kamar */}
        <Route path="/TarifKamar" element={<ProtectedRoute><TarifKamar /></ProtectedRoute>} />
        <Route path="/tarifkamar" element={<ProtectedRoute><TarifKamar /></ProtectedRoute>} />

        {/* Route Pengeluaran Uang Rumah Sakit (PURS) */}
        <Route path="/DataPURS" element={<ProtectedRoute><DataPURS /></ProtectedRoute>} />
        <Route path="/datapurs" element={<ProtectedRoute><DataPURS /></ProtectedRoute>} />

        {/* Route Pendaftaran Pasien Rawat Inap */}
        <Route path="/PasienRI" element={<ProtectedRoute><PasienRI /></ProtectedRoute>} />
        <Route path="/pasienri" element={<ProtectedRoute><PasienRI /></ProtectedRoute>} />

        {/* Route Master Data Pasien */}
        <Route path="/DataPasien" element={<ProtectedRoute><DataPasien /></ProtectedRoute>} />
        <Route path="/datapasien" element={<ProtectedRoute><DataPasien /></ProtectedRoute>} />

        {/* Route Master Data Penunjang */}
        <Route path="/DataPenunjang" element={<ProtectedRoute><DataPenunjang /></ProtectedRoute>} />
        <Route path="/datapenunjang" element={<ProtectedRoute><DataPenunjang /></ProtectedRoute>} />

        {/* Route Input Hasil Lab */}
        <Route path="/HasilLab" element={<ProtectedRoute><HasilLab /></ProtectedRoute>} />
        <Route path="/hasillab" element={<ProtectedRoute><HasilLab /></ProtectedRoute>} />

        {/* Route Input Hasil Radiologi */}
        <Route path="/HasilRad" element={<ProtectedRoute><HasilRad /></ProtectedRoute>} />
        <Route path="/hasilrad" element={<ProtectedRoute><HasilRad /></ProtectedRoute>} />

        {/* Route Dosis Obat Pasien */}
        <Route path="/SignaObat" element={<ProtectedRoute><SignaObat /></ProtectedRoute>} />
        <Route path="/signaobat" element={<ProtectedRoute><SignaObat /></ProtectedRoute>} />

        {/* Route Daftar Rekap Piutang */}
        <Route path="/RekapPiutang" element={<ProtectedRoute><RekapPiutang /></ProtectedRoute>} />
        <Route path="/rekappiutang" element={<ProtectedRoute><RekapPiutang /></ProtectedRoute>} />

        {/* Route Buku Kas Kasir */}
        <Route path="/KasKasir" element={<ProtectedRoute><KasKasir /></ProtectedRoute>} />
        <Route path="/KasBendahara" element={<ProtectedRoute><KasBendahara /></ProtectedRoute>} />
        <Route path="/kasbendahara" element={<ProtectedRoute><KasBendahara /></ProtectedRoute>} />
        <Route path="/bayarpiutang" element={<ProtectedRoute><BayarPiutang /></ProtectedRoute>} />
        <Route path="/BayarPiutang" element={<ProtectedRoute><BayarPiutang /></ProtectedRoute>} />
        <Route path="/kaskasir" element={<ProtectedRoute><KasKasir /></ProtectedRoute>} />

        <Route path="/TrsLaboratorium" element={<ProtectedRoute><TrsLaboratorium /></ProtectedRoute>} />
        <Route path="/TrsRadiologi" element={<ProtectedRoute><TrsRadiologi /></ProtectedRoute>} />
        <Route path="/TrsRuangRawat" element={<ProtectedRoute><TrsRuangRawat /></ProtectedRoute>} />
        <Route path="/trslaboratorium" element={<ProtectedRoute><TrsLaboratorium /></ProtectedRoute>} />
        <Route path="/trsradiologi" element={<ProtectedRoute><TrsRadiologi /></ProtectedRoute>} />
        <Route path="/trsruangrawat" element={<ProtectedRoute><TrsRuangRawat /></ProtectedRoute>} />

        {/* Route Transaksi Penjualan Obat Apotek */}
        <Route path="/TrsApotek" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/trsapotek" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/TrsApotek/*" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/trsapotek/*" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/TransaksiApotek" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/transaksiapotek" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/TransaksiObat" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/transaksiobat" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/PenjualanObat" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/penjualanobat" element={<ProtectedRoute><TrsApotek /></ProtectedRoute>} />
        <Route path="/TarifLab" element={<ProtectedRoute><TarifLab /></ProtectedRoute>} />
        <Route path="/tariflab" element={<ProtectedRoute><TarifLab /></ProtectedRoute>} />
        <Route path="/AturanJasaMedisBPJS" element={<ProtectedRoute><AturanJasaMedisBPJS /></ProtectedRoute>} />
        <Route path="/aturanjasamedisbpjs" element={<ProtectedRoute><AturanJasaMedisBPJS /></ProtectedRoute>} />
        <Route path="/PembuatanTagihan" element={<ProtectedRoute><PembuatanTagihan /></ProtectedRoute>} />
        <Route path="/pembuatantagihan" element={<ProtectedRoute><PembuatanTagihan /></ProtectedRoute>} />
        <Route path="/ValidasiRekananPerusahaan" element={<ProtectedRoute><ValidasiRekananPerusahaan /></ProtectedRoute>} />
        <Route path="/validasirekananperusahaan" element={<ProtectedRoute><ValidasiRekananPerusahaan /></ProtectedRoute>} />

        {/* Route Laporan Rekapitulasi Jurnal Kasir / Bendahara */}
        <Route path="/LaporanRekapJurnalKasir" element={<ProtectedRoute><LaporanRekapJurnalKasir /></ProtectedRoute>} />
        <Route path="/laporanrekapjurnalkasir" element={<ProtectedRoute><LaporanRekapJurnalKasir /></ProtectedRoute>} />
        <Route path="/laporan_rekap_jurnal_kasir" element={<ProtectedRoute><LaporanRekapJurnalKasir /></ProtectedRoute>} />
        <Route path="/rekap_jurnal_kasir" element={<ProtectedRoute><LaporanRekapJurnalKasir /></ProtectedRoute>} />
        <Route path="/prnjrnksr" element={<ProtectedRoute><LaporanRekapJurnalKasir /></ProtectedRoute>} />

        {/* Route Pembayaran Jasa Medis Dokter */}
        <Route path="/BayarJasaMedis" element={<ProtectedRoute><BayarJasaMedis /></ProtectedRoute>} />
        <Route path="/bayarjasamedis" element={<ProtectedRoute><BayarJasaMedis /></ProtectedRoute>} />
        <Route path="/jasamedis" element={<ProtectedRoute><BayarJasaMedis /></ProtectedRoute>} />

        {/* Route Aturan Jual Obat */}
        <Route path="/AturanJual" element={<ProtectedRoute><AturanJual /></ProtectedRoute>} />
        <Route path="/aturanjual" element={<ProtectedRoute><AturanJual /></ProtectedRoute>} />

        {/* Route Pembuatan Resume Medis */}
        <Route path="/ResumMedis" element={<ProtectedRoute><ResumeMedis /></ProtectedRoute>} />
        <Route path="/resummedis" element={<ProtectedRoute><ResumeMedis /></ProtectedRoute>} />
        <Route path="/ResumeMedis" element={<ProtectedRoute><ResumeMedis /></ProtectedRoute>} />
        <Route path="/resumemedis" element={<ProtectedRoute><ResumeMedis /></ProtectedRoute>} />

        {/* Route Cek Kelengkapan Tagihan */}
        <Route path="/CekKelengkapanTagihan" element={<ProtectedRoute><CekKelengkapanTagihan /></ProtectedRoute>} />
        <Route path="/cekkelengkapantagihan" element={<ProtectedRoute><CekKelengkapanTagihan /></ProtectedRoute>} />
        <Route path="/Cek_Kelengkapan_Tagihan" element={<ProtectedRoute><CekKelengkapanTagihan /></ProtectedRoute>} />
        <Route path="/cek_kelengkapan_tagihan" element={<ProtectedRoute><CekKelengkapanTagihan /></ProtectedRoute>} />

        {/* Route Laporan Penjualan Gudang Apotek (Finance) */}
        <Route path="/LapApotekFinance" element={<ProtectedRoute><LapApotekFinance /></ProtectedRoute>} />
        <Route path="/lapapotekfinance" element={<ProtectedRoute><LapApotekFinance /></ProtectedRoute>} />
        <Route path="/LapApotekFinance/*" element={<ProtectedRoute><LapApotekFinance /></ProtectedRoute>} />
        <Route path="/lapapotekfinance/*" element={<ProtectedRoute><LapApotekFinance /></ProtectedRoute>} />
        <Route path="/LaporanApotekFinance" element={<ProtectedRoute><LapApotekFinance /></ProtectedRoute>} />
        <Route path="/laporan_apotek_finance" element={<ProtectedRoute><LapApotekFinance /></ProtectedRoute>} />

        {/* Fallback ke login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;